export default "__VITE_ASSET__DAv8LGj8__"